module.exports = function (c, d, f, g) {
  f = f || {};
  this.id = c;
  this.name = d;
  this.score = f.player_score || 0;
  this.kills = f.player_kills || 0;
  this.deaths = f.player_deaths || 0;
  this.wins = f.player_wins || 0;
  this.hack = ~~(f.player_hack || 0);
  this.games = f.player_games_played || 0;
  this.clan = f.player_clanid;
  this.funds = f.player_funds || 0;
  this.featured = ~~(f.player_featured || 0);
  this.clan = f.player_clan || null;
  this.timePlayed = f.player_timeplayed || 0;
  this.skins = f.skins || [];
  this.lastReward = f.player_lastreward || 0;
  this.isDev = ~~(f.player_developer || 0);
  this.following = f.player_following || 0;
  this.followers = f.player_followed || 0;
  this.followInd = f.player_follow || 0;
  this.stats = f.player_stats ? JSON.parse(f.player_stats) : {};
  this.partnerName = f.partner_name || null;
  this.partnerApp = f.partner_approved || 0;
  this.regionInd = f.player_region;
  this.isMod = ~~(f.player_moderator || 0);
  this.elo = f.player_elo || 0;
  this.elo2 = f.player_elo2 || 0;
  this.elo4 = f.player_elo4 || 0;
  this.chal = f.player_chal || 0;
  this.virus = ~~(f.player_infected || 0);
  this.premiumT = f.player_premium || 0;
  this.premiumT = this.premiumT < 0 ? 0 : this.premiumT;
  this.pType = f.player_type || 0;
  this.has2FA = ~~(f.player_2FA ? 1 : 0);
  this.alias = (this.premiumT && f.player_alias) || d;
  this.createDate = f.player_datenew || "";
  this.twitch = f.tw_twitchname || null;
  this.isCreationMod = ~~(f.player_mapmod || 0);
  this.clanDeaths = f.clan_deaths || 0;
  this.clanKills = f.clan_kills || 0;
  this.clanCon = f.clan_contract || null;
  this.clanRegion = f.clan_regionid || 0;
  this.clanRank = f.clan_rank || 0;
  this.jobRating = f.jobrating || 0;
  this.jobRatingPos = f.jobratingpositive || 0;
  this.setData = function (h) {
    this.kills = h[1];
    this.wins = h[2];
    this.games = h[3];
    this.deaths = h[4];
    this.funds = h[5];
    this.score = h[6];
    this.updateLevel();
    this.clan = h[7];
    this.timePlayed = h[8];
    this.featured = ~~h[9];
    this.skins = h[10];
    this.lastReward = h[11];
    this.isDev = ~~h[12];
    this.following = h[13];
    this.followers = h[14];
    this.followInd = h[15];
    this.stats = h[16];
    this.hack = ~~h[17];
    this.partnerName = h[18];
    this.partnerApp = h[19];
    this.regionInd = h[20];
    this.isMod = ~~h[21];
    this.elo = h[22];
    this.elo2 = h[23];
    this.elo4 = h[24];
    this.chal = h[25];
    this.virus = ~~h[26];
    this.premiumT = h[27];
    this.has2FA = ~~h[28];
    this.alias = (this.premiumT && h[29]) || this.name;
    this.createDate = h[30];
    this.twitch = h[31];
    this.isCreationMod = ~~h[32];
    this.clanDeaths = h[33];
    this.clanKills = h[34];
    this.clanCon = h[35];
    this.clanRegion = h[36];
    this.clanRank = h[37];
    this.jobRating = h[38];
    this.jobRatingPos = h[39];
    this.updatePerms();
  };
  this.updateLevel = function () {
    var h = g.rankVar * Math.sqrt(this.score);
    this.level = Math.floor(h);
    this.levelProg = Math.round((h - this.level) * 100);
    this.level = Math.max(1, this.level);
  };
  this.updateLevel();
  this.updatePerms = function () {
    this.canFlag = this.isDev || this.isMod;
    this.canTeleport = this.isDev;
    this.canSuicide = this.isDev;
    this.canVerify = this.isDev;
    this.canGlobalKick = this.isDev || this.isMod;
    this.canGlobalBan = this.isDev || this.isMod;
    this.canViewReports = this.isDev || this.isMod;
    this.canFeatureCreations = this.isDev;
    this.canDeleteCreations = this.isDev || this.isCreationMod;
  };
  this.updatePerms();
  this.getData = function () {
    return [
      this.id,
      this.kills,
      this.wins,
      this.games,
      this.deaths,
      this.funds,
      this.score,
      this.clan,
      this.timePlayed,
      this.featured,
      this.skins,
      this.lastReward,
      this.isDev,
      this.following,
      this.followers,
      this.followInd,
      this.stats,
      this.hack,
      this.partnerName,
      this.partnerApp,
      this.regionInd,
      this.isMod,
      this.elo,
      this.elo2,
      this.elo4,
      this.chal,
      this.virus,
      this.premiumT,
      this.has2FA,
      this.alias,
      this.createDate,
      this.twitch,
      this.isCreationMod,
      this.clanDeaths,
      this.clanKills,
      this.clanCon,
      this.clanRegion,
      this.clanRank,
      this.jobRating,
      this.jobRatingPos,
    ];
  };
};
